export default class BranchOffice {
  static async retrieve(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `query {
        branchOfficeRetrieve(id: ${id}) {
          id
          active
          name
          description
          closeTime
          openTime
          phoneNumber
          company {
            id
            name
          }
          address
          locality
          affiliate
          state
          country
          latitude
          longitude
          polygon
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.branchOfficeRetrieve;
  }

  static async all(payload) {
    const response = await payload.axios.post(
      '/graphql/',
      `query{
        branchOfficeList(affiliate: ${payload.affiliate}) {
          results {
            affiliate
            id
            name
            description
            openTime
            closeTime
            phoneNumber
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.branchOfficeList.results.reverse();
  }

  static async allOfCompany(axios, active, company) {
    const response = await axios.post(
      '/graphql/',
      `query{
        branchOfficeList (active: ${active}, company: ${company}) {
          results {
            id
            name
            affiliate
            description
            openTime
            closeTime
            phoneNumber
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.branchOfficeList.results.reverse();
  }

  static async filter(axios, active, company) {
    const response = await axios.post(
      '/graphql/',
      `query{
        branchOfficeList (active: ${active}, company: ${company}) {
          results {
            id
            affiliate
            name
            description
            openTime
            closeTime
            phoneNumber
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.branchOfficeList.results.reverse();
  }

  static async delete(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `mutation{
        deleteBranchOffice(id: ${id}){
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.deleteBranchOffice.ok;
  }

  static async create(axios, name, description, openTime, closeTime, phoneNumber, company, address,
                      locality, state, country, latitude, longitude, polygon, affiliate) {
    const companyField = (company > 0) ? `company: ${company},` : ``;
      const newDescrip = description.replace(/(\r\n|\n|\r)/gm, "");

    const response = await axios.post(
      '/graphql/',
      `mutation{
        createBranchOffice(newBranchoffice: {
          ${companyField}
          name: "${name}", 
          description: "${newDescrip}", 
          openTime: "${openTime}",
          closeTime: "${closeTime}",
          phoneNumber: "${phoneNumber}",
          address: "${address}",
          locality: "${locality}",
          state: "${state}",
          country: "${country}",
          latitude: "${latitude}",
          longitude: "${longitude}",
          polygon: "${polygon}",
          affiliate: ${affiliate},
        }) {
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.createBranchOffice.ok;
  }


  static async edit(axios, id, name, description, openTime, closeTime, phoneNumber, company, address,
                      locality, state, country, latitude, longitude, polygon, affiliate) {
    const companyField = (company > 0) ? `company: ${company},` : ``;
      const newDescrip = description.replace(/(\r\n|\n|\r)/gm, "");

    const response = await axios.post(
      '/graphql/',
      `mutation{
        updateBranchOffice(newBranchoffice: {
          ${companyField}
          id: ${id},
          name: "${name}", 
          description: "${newDescrip}", 
          openTime: "${openTime}",
          closeTime: "${closeTime}",
          phoneNumber: "${phoneNumber}",
          address: "${address}",
          locality: "${locality}",
          state: "${state}",
          country: "${country}",
          latitude: "${latitude}",
          longitude: "${longitude}",
          polygon: "${polygon}",
          affiliate: ${affiliate},
        }) {
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.updateBranchOffice.ok;
  }


}
